import React from 'react';

interface HighlightedTextProps {
  text: string;
  searchText: string;
}

const HighlightedText = ({ text, searchText }: HighlightedTextProps) => {
  if (!searchText) return <>{text}</>;

  const lowerText = text.toLocaleLowerCase();
  const lowerSearchText = searchText.toLocaleLowerCase();

  const segments = [];
  let startIndex = 0;
  let matchIndex;

  while ((matchIndex = lowerText.indexOf(lowerSearchText, startIndex)) !== -1) {
    // add text before the match
    if (matchIndex > startIndex) {
      segments.push(
        <span key={`text-${startIndex}`}>{text.substring(startIndex, matchIndex)}</span>
      );
    }

    // add the highlighted match
    segments.push(
      <mark key={`mark-${matchIndex}`}>
        {text.substring(matchIndex, matchIndex + lowerSearchText.length)}
      </mark>
    );

    startIndex = matchIndex + lowerSearchText.length;
  }

  // finally, add any remaining text after the last match
  if (startIndex < text.length) {
    segments.push(<span key={`text-${startIndex}`}>{text.substring(startIndex)}</span>);
  }

  return <>{segments}</>;
};

export default HighlightedText;
